require('./brokerCustomWalletInterveners.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @utils
const { formatText } = require('core/i18n').i18n;

// @component
const OKModal = require('components/commons/OKModal/OKModal');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ commons
const { EmptyState } = require('commonsComponents/emptyState');

class BrokerCustomWalletInterveners extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancelView = this.handleCancelView.bind(this);
    }

    getIntervenersName(list) {
        return (list.map((intervener, index) => {
            return (
                <div className="broker-custom-wallet-view-interveners__name-item" key={index}>{intervener}</div>
            );
        }));
    }

    handleCancelView() {
        this.props.cancelViewInterveners();
    }

    intervenersList() {
        const { immBrokerCustomWalletInterveners } = this.props;

        const contractsIntervention = immBrokerCustomWalletInterveners.get('contractsIntervention');
        const contractId = immBrokerCustomWalletInterveners.get('contractView');
        const intervenersList = contractsIntervention.getIn([contractId, 'interveners']);

        return intervenersList.map((intervener, index) => {
            const interventionType = intervener.get('interventionType');
            const nameInterveners = this.getIntervenersName(intervener.get('nameInterveners'));

            return (
                <div className="broker-custom-wallet-view-interveners__item" key={index}>
                    <h3 className="broker-custom-wallet-view-interveners__type">
                        <div>{formatText(`interventionTypes-${interventionType.toUpperCase().trim()}`)}</div>
                    </h3>
                    <div className="broker-custom-wallet-view-interveners__name">
                        {nameInterveners}
                    </div>
                </div>
            );
        });
    }

    render() {
        const { immBrokerCustomWalletInterveners } = this.props;
        const waitingViewInterveners = immBrokerCustomWalletInterveners.get('waitingCustomWalletviewInterveners');

        if (waitingViewInterveners) {
            let interveners;
            if (immBrokerCustomWalletInterveners.get('isFetching')) {
                interveners = <LoadingSection />;
            }
            else {
                if (immBrokerCustomWalletInterveners.get('error')) {
                    const emptyStateInterveners = formatText('brokerCustomWallet-emptyStateInterveners');
                    interveners = <EmptyState primaryText={emptyStateInterveners} iconType="nointernet-wealth"/>;
                }
                else {
                    interveners = this.intervenersList();
                }
            }

            return (
                <OKModal
                    content={interveners}
                    isOpen={true}
                    onCloseCallback={this.handleCancelView}
                    title="brokerCustomWallet-viewIntervenersTitle"
                />
            )
        }
        return null;
    }
}

BrokerCustomWalletInterveners.propTypes = {
    immBrokerCustomWalletInterveners: PropTypes.object.isRequired,
    cancelViewInterveners: PropTypes.func.isRequired,
};

module.exports = BrokerCustomWalletInterveners;
